import styled from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';
import { Spacer } from '@lux/tokens';

export const OuterWrapper = styled.div<{
    shouldRenderGRETreatment: boolean;
    isGRETab: boolean;
    $isNoThbVariant?: boolean;
}>`
    ${({ isGRETab, shouldRenderGRETreatment }) =>
        isGRETab &&
        shouldRenderGRETreatment &&
        `
    top: 110px;
    z-index: 1;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px;
    `};

    margin-bottom: ${props => (props.$isNoThbVariant ? '0' : Spacer.S)};
    ${screenBiggerThan(Screen.smallTablet)} {
        margin-bottom: ${props => (props.$isNoThbVariant ? '0' : '24px')};
    }
`;

// TODO: check this while extracting GRE
export const Wrapper = styled.div<{
    shouldRenderGRETreatment: boolean;
    isMainTab: boolean;
    isGRETab: boolean;
    $isNoThbVariant?: boolean;
    $isSmallThbVariant?: boolean;
}>`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 400px; // Default Height, Modified below for gre experiments.
    ${({ $isSmallThbVariant }) => {
        return (
            $isSmallThbVariant &&
            `
                height: auto;
                aspect-ratio: 3/2;
            `
        );
    }};

    ${({ $isNoThbVariant }) => {
        return (
            $isNoThbVariant &&
            `
                height: auto;
            `
        );
    }};

    // This is the height of the banner when the GRE Experiment is active and user is on the main tab
    // Find more detail about this experiment here
    // https://docs.google.com/document/d/1H-B1BNx5v4_A2HHI9Re7VnPv8APthCjT7rIvmBzWmAE
    ${({ shouldRenderGRETreatment, isMainTab }) => {
        return (
            shouldRenderGRETreatment &&
            isMainTab &&
            `
                height: 12.5rem;
            `
        );
    }};

    // This is the height of the banner when the GRE Experiment is active and user is on the GRE tab
    // isGreTab true -> tab.globalRetailEvent is true
    // Find more detail about this experiment here
    // https://docs.google.com/document/d/1H-B1BNx5v4_A2HHI9Re7VnPv8APthCjT7rIvmBzWmAE
    ${({ isGRETab, shouldRenderGRETreatment }) => {
        return (
            isGRETab &&
            shouldRenderGRETreatment &&
            `
                height: 80px;
            `
        );
    }};

    ${screenBiggerThan(Screen.smallTablet)} {
        height: 335px;
        ${({ $isNoThbVariant }) => {
            return (
                $isNoThbVariant &&
                `
                height: auto;
            `
            );
        }};

        ${({ $isSmallThbVariant }) => {
            return (
                $isSmallThbVariant &&
                `
                height: auto;
                aspect-ratio: 9 / 4;
            `
            );
        }};
    }
    ${screenBiggerThan(Screen.tablet)} {
        height: 500px;
        ${({ $isNoThbVariant }) => {
            return (
                $isNoThbVariant &&
                `
                height: auto;
            `
            );
        }};
        ${({ $isSmallThbVariant }) => {
            return (
                $isSmallThbVariant &&
                `
                height: auto;
                aspect-ratio: 3/1;
            `
            );
        }};
    }
`;

export const SpinnerWrapper = styled.div`
    width: 100%;
    margin: 60px auto 30px;
    display: flex;
    justify-content: center;

    ${screenBiggerThan(Screen.smallTablet)} {
        margin-top: 75px;
    }
`;
